"use client";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useTranslation } from "@/hooks/useTranslation.hook";

interface LeaveAiChatDialogProps {
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
  readonly onConfirm: () => void;
  readonly onCancel: () => void;
}

const LeaveAiChatDialog = ({
  open,
  onOpenChange,
  onConfirm,
  onCancel,
}: LeaveAiChatDialogProps) => {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="leave-ai-chat-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle data-testid="leave-ai-chat-dialog-title">
            {t("Are you sure you want to leave?")}
          </AlertDialogTitle>
          <AlertDialogDescription data-testid="leave-ai-chat-dialog-description">
            {t(
              "You have an active conversation Leaving will clear your chat history Continue?"
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            onClick={onCancel}
            data-testid="leave-ai-chat-cancel-button"
          >
            {t("Cancel")}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            data-testid="leave-ai-chat-continue-button"
          >
            {t("Ok")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default LeaveAiChatDialog;
